import { getEventQueue } from '../../../shared/utils/eventQueue';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getRegistry } from '@cian/mf-registry/browser';
import { TApplicationState, TDispatch } from '../../../shared/types/redux';
import { isCompareFlightTooltipShow } from '../../../shared/utils/isCompareFlightTooltipShow';
import { createReduxStore } from '../../../shared/utils/redux';
import { getFlatTourSchedule } from '../flatTourBooking';
import { getTelemetry } from '@cian/telemetry/browser';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const microfrontendsRegistry = getRegistry();
  const microfrontendsAPI = createMicrofrontendsAPI();
  const telemetry = getTelemetry();
  const eventQueue = getEventQueue();

  const serverInitialState = config.getStrict<TApplicationState>('initialState');
  const initialState: TApplicationState = {
    ...serverInitialState,
    compareFlightTooltip: {
      isCompareFlightTooltipShow: isCompareFlightTooltipShow(window.location.search),
      isCompareFlightModalOpen: false,
    },
  };

  const reduxContext = {
    config,
    httpApi,
    logger,
    microfrontendsRegistry,
    microfrontendsAPI,
    telemetry,
    eventQueue,
  };

  const store = createReduxStore(initialState, reduxContext, true);
  (store.dispatch as TDispatch)(getFlatTourSchedule());

  return store;
}
